// extracted by mini-css-extract-plugin
export default {"itemContainer":"FullFormStructure_itemContainer__iRgHk"};